var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [
      _vm._v(_vm._s(_vm.global.type == "manage" ? "管理端" : "客户端"))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "info_box" }, [
      _c(
        "div",
        { staticClass: "kaka-btn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "success", size: "small", icon: "el-icon-brush" },
              on: { click: _vm.toKaka }
            },
            [_vm._v("月亮湾设计智能体")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "name" },
        [
          _c("el-button", { attrs: { type: "text", disabled: "" } }, [
            _vm._v(_vm._s(_vm.username))
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "avatar" },
        [
          _c(
            "el-button",
            { attrs: { type: "text" }, on: { click: _vm.toExit } },
            [_vm._v("退出登录")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c833af0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c833af0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderComponent.vue
// module id = null
// module chunks = 